var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Container',{staticClass:"affiliations"},[_c('ul',{staticClass:"affiliations-list"},_vm._l((_vm.affiliations),function(affiliation){return _c('Affiliation',{key:affiliation.id,attrs:{"affiliation":affiliation}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }